import { useScreenSize } from '@hooks';
import { Flex, theme, Typography } from '@styles';
import { bool, number, string } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TestAnswer = ({ explanation, index, isCorrect, isRight, title }) => {
  const { isMobile } = useScreenSize();
  const { i18n } = useTranslation();

  return (
    <Flex
      borderBottomColor={theme.colors.white[30]}
      borderBottomStyle="solid"
      borderBottomWidth={1}
      width="100%"
    >
      {isMobile ? (
        <Flex
          alignItems="flex-start"
          flex={1}
          gap={12}
          justifyContent="flex-start"
          pb={24}
          pr={24}
          pt={index === 0 ? 0 : 24}
        >
          <Flex
            backgroundColor={
              isCorrect ? theme.colors.brightGreen : theme.colors.red[100]
            }
            flexShrink={0}
            height="100%"
            width={8}
          />
          <Flex flexDirection="column">
            <Flex gap={12}>
              <Typography
                color={theme.colors.white[100]}
                textAlign="left"
                variant="MS-regular-s18-lh28"
                width={16}
              >
                {index + 1}
              </Typography>
              <Typography
                color={theme.colors.white[100]}
                textAlign="left"
                variant="MS-bold-s16-lh25"
              >
                {title}
              </Typography>
            </Flex>
            <Flex
              alignItems="flex-start"
              flex={1}
              flexDirection="column"
              justifyContent="flex-start"
              {...(!isCorrect && {
                p: 16,
                pl: 20,
              })}
            >
              {!isCorrect && (
                <>
                  <Typography
                    color={theme.colors.schoolBusYellow[100]}
                    textAlign="left"
                    variant="MS-semibold-s16-lh25"
                  >
                    {i18n.t('TestPage.CorrectAnswer')}:{' '}
                    {isRight ? 'Right' : 'Wrong'}
                  </Typography>
                  <Typography
                    color={theme.colors.white[100]}
                    fontStyle="italic"
                    textAlign="left"
                    variant="MS-regular-s16-lh25"
                  >
                    {explanation}
                  </Typography>
                </>
              )}
            </Flex>
          </Flex>
        </Flex>
      ) : (
        <>
          <Flex
            alignItems="flex-start"
            borderRightColor={theme.colors.white[30]}
            borderRightStyle="solid"
            borderRightWidth={1}
            flex={1}
            gap={12}
            justifyContent="flex-start"
            pb={24}
            pr={24}
            pt={index === 0 ? 0 : 24}
          >
            <Flex
              backgroundColor={
                isCorrect ? theme.colors.brightGreen : theme.colors.red[100]
              }
              flexShrink={0}
              height="100%"
              width={8}
            />
            <Typography
              color={theme.colors.white[100]}
              textAlign="left"
              variant="MS-regular-s18-lh28"
              width={16}
            >
              {index + 1}
            </Typography>
            <Typography
              color={theme.colors.white[100]}
              textAlign="left"
              variant="MS-bold-s18-lh28"
            >
              {title}
            </Typography>
          </Flex>
          <Flex
            alignItems="flex-start"
            flex={1}
            flexDirection="column"
            justifyContent="flex-start"
            pb={24}
            pt={index === 0 ? 0 : 24}
            px={24}
          >
            {!isCorrect && (
              <>
                <Typography
                  color={theme.colors.schoolBusYellow[100]}
                  textAlign="left"
                  variant="MS-regular-s18-lh28"
                >
                  {i18n.t('TestPage.CorrectAnswer')}:{' '}
                  {isRight ? 'Right' : 'Wrong'}
                </Typography>
                {!isRight && (
                  <Typography
                    color={theme.colors.white[100]}
                    fontStyle="italic"
                    textAlign="left"
                    variant="MS-regular-s18-lh28"
                  >
                    {explanation}
                  </Typography>
                )}
              </>
            )}
          </Flex>
        </>
      )}
    </Flex>
  );
};

TestAnswer.propTypes = {
  explanation: string.isRequired,
  index: number.isRequired,
  isCorrect: bool.isRequired,
  isRight: bool.isRequired,
  title: string.isRequired,
};

export default TestAnswer;
